<script setup lang="js">
import {onMounted, ref, unref} from "vue";
import {useRoute, useRouter} from "vue-router";

const isMode = ref(false)
const height = ref(200)
const width = ref()
const visible = ref(false)
const indexs = ref(0)
onMounted(() => {
  const router=useRoute()
  setTimeout(()=>{
    console.log(router.name)
    if (!router.name){
      indexs.value=0
    }else if (router.name=='about'){
      indexs.value=1
    }else if (router.name=='business'){
      indexs.value=2
    }else if (router.name=='project'){
      indexs.value=3
    }else if (router.name=='create'){
      indexs.value=4
    }else if (router.name=='cooperate'){
      indexs.value=5
    }else if (router.name=='justCreate'){
      indexs.value=6
    }else if (router.name=='service'){
      indexs.value=7
    }else {
      indexs.value=8
    }
  },10)
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log(userAgent)
  isMode.value = /android|iphone|ipad|ipod/i.test(userAgent);
  console.log(isMode.value)
  width.value=window.innerWidth

  if (!isMode.value&&width.value<1024){
    isMode.value=true
  }

  if (!isMode.value) {
    height.value = 700;
  }
  if (width.value<700){
    height.value = width.value/2.1;
  }else {
    height.value = width.value/2.5;
  }

  console.log(width.value,isMode.value,height.value)
})
window.addEventListener('resize',()=>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  console.log(userAgent)
  isMode.value = /android|iphone|ipad|ipod/i.test(userAgent);
  console.log(isMode.value)
  width.value=window.innerWidth

  if (!isMode.value&&width.value<1024){
    isMode.value=true
  }

  if (!isMode.value) {
    height.value = 700;
  }
  if (width.value<700){
    height.value = width.value/2.1;
  }else {
    height.value = width.value/2.5;
  }
  console.log(width.value,isMode.value,height.value)
})


const menuClick = (index) => {
  // isPhone.value= !isPhone.value
  if (isMode.value) {
    visible.value = !visible.value;
  }
  console.log(index)
  if (index!=null){
    console.log(index)
    indexs.value = index;
  }

}
const menuClickIS =  ()=> {
  // isPhone.value= !isPhone.value
  if (isMode.value) {
    visible.value = !visible.value;
  }
}
</script>

<template>
  <div class="container mx-auto pt-[4.19rem] flex justify-between">
    <div class="w-full ">
      <img src="https://cos5.51tgqj.com/techming/img/MJlogo@2x.png" class="w-3/4 md:w-3/4 lg:w-1/2"/>
    </div>
    <div class="lg:hidden flex justify-end">
      <el-popover
          :visible="visible"
      >
        <template #reference>
          <img src="https://cos5.51tgqj.com/techming/img/menu.png" class="w-1/2 items-end" @click="menuClickIS"/>
        </template>
        <template #default>
          <div class="bg-[#030C52] w-full tr flex flex-row  rounded-md backdrop-opacity-95">
            <div class="container px-3">
              <!--弹出框-->
              <ul class="md:flex items-start flex-col mx-auto md:static">
                <li class="basis-1/8 justify-center ml-5 md:ml-5 lg:ml-0 mt-5 md:mt-5  lg:mt-0">
                  <router-link to="/" class="text-[1.5rem]   hover:text-green-500"
                               :class="indexs===0?'text-green-500':'text-white'" @click="menuClick(0)">首页
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/about" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===1?'text-green-500':'text-white'" @click="menuClick(1)">关于我们
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/business" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===2?'text-green-500':'text-white'" @click="menuClick(2)">业务矩阵
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/project" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===3?'text-green-500':'text-white'" @click="menuClick(3)">项目案例
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/create" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===4?'text-green-500':'text-white'" @click="menuClick(4)">就创家门口
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/cooperate" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===5?'text-green-500':'text-white'" @click="menuClick(5)">合作模式
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 ">
                  <router-link to="/justCreate" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===6?'text-green-500':'text-white'" @click="menuClick(6)">就创动态
                  </router-link>
                </li>
                <li class="basis-1/8 ml-5 md:ml-5 lg:ml-0 mb-5 md:mb-5  lg:mb-0">
                  <router-link to="/service" class="text-[1.5rem]  hover:text-green-500"
                               :class="indexs===7?'text-green-500':'text-white'" @click="menuClick(7)">服务支持
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
  <transition>
    <div class="bg-[#030C52] flex flex-row lg:mt-16" v-if="!isMode">
      <div class="container mx-auto my-[1rem] px-4 md:px-4 sm:px-4">
        <!--弹出框-->
        <ul class="md:flex md:items-center sm:flex sm:items-center justify-between items-center mx-auto md:static sm:static">
          <li class="basis-1/8 justify-center ">
            <router-link to="/" class="text-[1.5rem]  hover:text-green-900"
                         :class="indexs===0?'text-green-500':'text-white'" @click="menuClick(0)">首页
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/about" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===1?'text-green-500':'text-white'" @click="menuClick(1)">关于我们
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/business" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===2?'text-green-500':'text-white'" @click="menuClick(2)">业务矩阵
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/project" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===3?'text-green-500':'text-white'" @click="menuClick(3)">项目案例
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/create" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===4?'text-green-500':'text-white'" @click="menuClick(4)">就创家门口
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/cooperate" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===5?'text-green-500':'text-white'" @click="menuClick(5)">合作模式
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/justCreate" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===6?'text-green-500':'text-white'" @click="menuClick(6)">就创动态
            </router-link>
          </li>
          <li class="basis-1/8 my-2">
            <router-link to="/service" class="text-[1.5rem]  hover:text-green-500"
                         :class="indexs===7?'text-green-500':'text-white'" @click="menuClick(7)">服务支持
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </transition>

  <div class="container mx-auto mt-4">
    <el-carousel :height="height+'px'" class="bg-[#161881]">
      <el-carousel-item>
        <div class="px-5">
          <img src="https://cos5.51tgqj.com/techming/img/zfcxx@2x.png" class="images"/>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="px-5">
          <img src="https://cos5.51tgqj.com/techming/img/MSCNYlb@2x.png" class="images"/>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="px-5">
          <img src="https://cos5.51tgqj.com/techming/img/qycnylb@2x.png" class="images"/>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style scoped>
.images {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


</style>
